export function randomUuid() {
    if ("randomUUID" in crypto) {
        return crypto.randomUUID()
    } else {
        /*                                                                                           */
        /*                                                                */
        /*                                                                 */
        return (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: string) => {
            const num = Number(c)
            return (num ^ ((crypto.getRandomValues(new Uint8Array(1))[0] & 15) >> (num / 4))).toString(16)
        })
    }
}
